import React from "react";
import { Organization } from "schema-dts";
import JSONLDTag from "./JSONLDTag";
import { getSrc, IGatsbyImageData, ImageDataLike } from "gatsby-plugin-image";

type Props = {
  logo: IGatsbyImageData;
  sameAs: string[];
};

export default function JSONLDTagOrganization({ logo, sameAs }: Props) {
  return (
    <JSONLDTag<Organization>
      data-testid="organization-ld"
      json={{
        "@context": "https://schema.org",
        "@type": "Organization",
        "@id": "https://www.dirtisgood.com/home.html",
        name: "Dirt is Good",
        url: "https://www.dirtisgood.com/home.html",
        logo: getSrc(logo as ImageDataLike),
        sameAs,
      }}
    />
  );
}
